import NavBar from "./navbar/NavBar";
import Message from "./views/messages/Message";
import Feed from "./views/feeds/Feed";
import Profile from "./views/profile/Profile";
import Explore from "./views/explore/Explore";
import Home from "./views/Home/Home";
import { BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom'
import Login from "./views/components/login/Login";
import Register from "./views/components/register/Register";
import { Outlet } from 'react-router-dom'
import './style.css'
import { useContext } from "react";
import AuthContext from "./context/AuthProvider";
import PasswordRest from './views/components/Password/PasswordRest'
import PswdResetLink from './views/components/PswdResetLink/PswdReset.jsx'
import Settings from "./views/components/Settings/Settings";

function App() {
  const { authState } = useContext(AuthContext)
  // console.log('from App: ', authState);

  const user = authState.user

  return (
    <div className="App">
      <Router >
        <Routes>
          <Route exact path="/login" element={user? <Navigate to='/' /> : <Login />} />
          <Route exact path="/register" element={user? <Navigate to='/' /> : <Register />} />
          <Route exact path="/password-reset/:id/:otp" element={user? <Navigate to='/' /> : < PasswordRest/>} />
          <Route exact path="/reset" element={user? <Navigate to='/' /> : < PswdResetLink/>} />

          <Route exact element={user ? <NavBarLayout /> : <Login />}>
            <Route path="/" element={user ? <Home />: <Navigate to='/login' />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/users" element={<Feed />} />
            <Route path="/message" element={<Message />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/profile/:username" element={<Profile />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}
const NavBarLayout = () => {
  return(
    <div className="fix__nav-layout">
      <NavBar />
      <Outlet />
    </div>
  )
}

export default App;
